import { defineStore } from 'pinia';

export const useAccessStore = defineStore('accessStore', {
  state: () => ({
    showNoAccess: false,
    noAccessMessage: "You don't have access to view this project.",
    projectId: '' as string,
    notFound: false
  }),
  actions: {
    resetAccessModal() {
      this.showNoAccess = false;
      this.noAccessMessage = '';
      this.projectId = '';
      this.notFound = false;
    },
    setNoAccess(projectId: string, message?: string) {
      this.showNoAccess = true;
      this.projectId = projectId;
      this.notFound = false;
      if (message) {
        this.noAccessMessage = message;
      }
    },
    setNotFound(projectId: string) {
      this.showNoAccess = true;
      this.projectId = projectId;
      this.notFound = true;
    }
  }
});
